import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekvozOzn: [] },
	filter: {
		VyrobekvozOzn: null as string | null,
		VyrazenPrp: null as boolean | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
